import { z } from 'zod';

const envSchema = z.object({
  VITE_DEFAULT_LOCALE: z.enum(['pt-BR', 'en-US', 'es-ES']).default('pt-BR'),
  VITE_SUPPORTED_LOCALES: z.string().default('pt-BR,en-US,es-ES'),
  VITE_FALLBACK_LOCALE: z.enum(['pt-BR', 'en-US', 'es-ES']).default('pt-BR'),
  VITE_API_ENDPOINT: z.string().default('http://localhost:8787'),
});

// Get env vars from import.meta.env
const getEnvVars = () => {
  const env: Record<string, string | undefined> = {};

  // Vite exposes env vars in import.meta.env
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    Object.keys(import.meta.env).forEach((key) => {
      if (key.startsWith('VITE_')) {
        env[key] = import.meta.env[key];
      }
    });
  }

  return env;
};

const parsed = envSchema.safeParse(getEnvVars());

if (!parsed.success) {
  console.warn('⚠️ Invalid i18n environment variables, using defaults:');
  console.warn(parsed.error.format());
}

export const config = {
  defaultLocale: (parsed.success ? parsed.data.VITE_DEFAULT_LOCALE : 'pt-BR') as
    | 'pt-BR'
    | 'en-US'
    | 'es-ES',
  supportedLocales: parsed.success
    ? (parsed.data.VITE_SUPPORTED_LOCALES.split(',') as Array<'pt-BR' | 'en-US' | 'es-ES'>)
    : ['pt-BR', 'en-US', 'es-ES'],
  fallbackLocale: (parsed.success ? parsed.data.VITE_FALLBACK_LOCALE : 'pt-BR') as
    | 'pt-BR'
    | 'en-US'
    | 'es-ES',
} as const;
